<template>
  <div>
    <el-col :lg="24" :md="24" :sm="24" :xl="24" :xs="24">
      <div class="head_width">
        <slot>
          <span class="head_text">仪海仪家</span>
          <img class="head_dingwei" src="../../assets/home/dingwei.png" />
          <span class="head_text head_text_cao_left">
            HI！{{
              $store.state.information != ""
                ? $store.state.information.name
                : ""
            }}
          </span>
          <!--          <img class="head_youxiang" src="../../assets/home/xiaoxi.png"/>-->
          <!--          <a class="xuanzhong wenzi" href="">-->
          <!--                                                    <span class="head_text head_text_xiaoxi_left">-->
          <!--                                                        消息12-->
          <!--                                                    </span>-->
          <!--          </a>-->
          <el-tooltip>
            <div slot="content">
              <img
                src="../../assets/home/xiaochengxu.jpg"
                class="img-xiaochengxu"
                style="width: 150px; height: 150px"
              />
            </div>
            <span class="head_text head_text_xiaoxi_left">
              <li class="el-icon-mobile-phone"></li>
              手机扫一扫</span
            >
          </el-tooltip>
          <span v-if="$store.state.total_unread == 0">
            <div class="yixiaoxing">
              <img
                src="../../assets/home/yixiaoxing1.png"
                alt=""
                class="image"
                @click="chat_list"
              />
            </div>
          </span>
          <el-badge v-else :value="$store.state.total_unread" class="item">
            <div class="yixiaoxing">
              <img
                src="../../assets/home/yixiaoxing1.png"
                alt=""
                class="image"
                @click="chat_list"
              />
            </div>
          </el-badge>
        </slot>
        <a class="xuanzhong wenzi youfudong">
          <el-dropdown>
            <span class="el-dropdown-link">
              <span
                class="hidden-md-and-down head_text head_text_wangzhan_left"
              >
                网站导航
              </span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <a class="top-right-link" href="/home.html#/"> 首页 </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/shop"> 聚义商城 </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/service/index"> 服务直达 </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/testing/index"> 检验检测 </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/general/index"> 仪兵仪将 </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/second_goods/index">
                  二手商品
                </a>
              </el-dropdown-item>
              <el-dropdown-item>
                <a class="top-right-link" href="#/college"> 仪小星讲堂 </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </a>
        <a class="xuanzhong wenzi youfudong">
          <el-tooltip class="item" effect="dark" placement="bottom">
            <div slot="content">
              <span v-if="config.phone">电话：{{ config.phone }}</span>
              <br />
              <span v-if="config.email">邮箱：{{ config.email }}</span>
            </div>
            <span class="hidden-md-and-down head_text head_text_kefu_left">
              客服中心
            </span>
          </el-tooltip>
        </a>
        <a class="xuanzhong wenzi youfudong" href="user.html#/trans/collection">
          <span class="head_text head_text_wode_left"> 我的收藏 </span>
        </a>
        <a
          class="xuanzhong wenzi youfudong"
          href="/user.html#/index"
          @click="tiaozhuan"
        >
          <span class="head_text head_text_shangjia_left"> 商家工作台 </span>
        </a>
        <a class="xuanzhong wenzi youfudong" href="/home.html#/">
          <span class="head_text head_text_shouye_left"> 首页 </span>
        </a>
        <a class="xuanzhong wenzi youfudong" href="/user.html#/">
          <span class="head_text head_text_denglu_left">
            {{ $store.state.information != "" ? "" : "登录/注册" }}
          </span>
        </a>
      </div>
    </el-col>
  </div>
</template>

<script>
export default {
  // name: "head",
  name: "head0",
  data() {
    return {
      config: {
        email: "",
        phone: "",
      },
      auth_info: "",
      unread_total: 0,
    };
  },
  methods: {
    tiaozhuan() {
      window.location.href;
    },
    chat_list() {
      if (this.auth_info.status === 101) {
        window.location.href = "/user.html#/login";
        this.$message({
          message: "请先登录！",
          type: "warning",
        });
      } else {
        window.location.href = "#/chat_new";
      }
    },
    getConfig: function () {
      var t = this;
      if (!this.config.email || !this.config.phone) {
        let url = window.config.api_url + "/user/config/site";
        this.axios.get(url).then((res) => {
          t.config.email = res.data.site.email;
          t.config.phone = res.data.site["service-phone"];
        });
      }
    },
    get_info() {
      var t = this;
      var aid = localStorage.getItem("uid");
      var url = window.config.api_url + "/user/info?token=" + aid;
      t.axios.get(url).then((res) => {
        t.auth_info = res.data;
      });
    },
  },
  computed: {
    get_unread() {
      return this.$store.state.total_unread;
    },
  },
  created() {
    this.getConfig();
    this.get_info();
    // this.unread_total = this.$store.state.total_unread;
    // console.log(this.unread_total,11111)
  },
};
</script>
<style scoped lang="less">
/*@import '../../assets/css/home_head.less';*/
.yixiaoxing {
  // margin-top: 20px;
  margin-left: 20px;
  height: 25px;
  width: 25px;
  // background-color: #ccc;
  display: inline-block;
  position: absolute;
  top: 6px;
  .image {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.youfudong {
  float: right;
}

.head_width {
  width: 80%;
  max-width: 1200px;
  margin-right: auto;
  margin-left: auto;
}

.head_text {
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #333333;
  line-height: 38px;
}
.head_dingwei {
  //float: ;
  margin-left: 5px;
  margin-top: 13px;
  position: absolute;
  width: 10px;
  height: 13px;
}
.head_text_cao_left {
  margin-left: 26px;
}
.head_youxiang {
  margin-left: 34px;
  margin-top: 13px;
  position: absolute;
  width: 17px;
  height: 13px;
}
.xuanzhong:hover {
  //color:#4E6EF2;
  text-decoration: none;
}
.wenzi {
  text-decoration: none;
}
.head_text_wangzhan_left {
  margin-left: 34px;
  cursor: pointer;
}
.top-right-link {
  text-decoration: none;
  color: #333;
  &:hover {
    text-decoration: none;
    color: #333;
  }
}
.head_text_cao_left {
  margin-left: 26px;
}

.head_text_xiaoxi_left {
  margin-left: 57px;
}

.head_text_denglu_left {
  margin-left: 202px;
}

.head_text_shouye_left {
  margin-left: 48px;
}

.head_text_shangjia_left {
  margin-left: 44px;
}

.head_text_wode_left {
  margin-left: 46px;
}

.head_text_kefu_left {
  margin-left: 50px;
}

.head_text_wangzhan_left {
  margin-left: 34px;
}
</style>